export const APP_TOKENS = {
  selectedLocation: "selected_location",
  selectedCountry: "selected_country",
  selectedCashier: "selected_cashier",
  locale: "locale",
};
